import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from './app.service';

@Injectable({ providedIn: 'root' })
export class ExternalFilingRequestService extends AppService {
  constructor(
    public http: HttpClient,
    @Inject('environment') environment: any
  ) {
    super(http, environment);
  }
  ///

  getExemptionFilingRequestDetail(id: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestDetail/${id}`),
      this.gethttpOptions()
    );
  }

  getFilingDetail(fillingId: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingDetail/${fillingId}`),
      this.gethttpOptions()
    );
  }

  postExistingExemptionFilingRequest(registrationControl: any){
    return this.http.post<any>(
      this.getEndpoint(`ExemptionFilingRequestBasic/PostId?id=${registrationControl}`,
      ),
        this.gethttpOptions()
    )
  }

  getExistingExemptionFilingRequest(registrationControl: any) {
    var userId = this.getUser().userId;
    var Id = registrationControl;
    console.log("ln 40 = ", this.gethttpOptions());
    return this.http.get<any>(
      this.getEndpoint(
        `ExemptionFilingBasic?RegistrationControlNumber=${registrationControl}`
      ),
      this.gethttpOptions()
    );
  }

  addToExistingExemptionFilingRequest(
    exemptionFilingId: any,
    requestTypeId: number, internalstatus: any, externalStatusTypeId: any
  ) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(`ExemptionFilingRequestBasic/RequestType`),
      `{ "exemptionFilingId": ${exemptionFilingId}, "exemptionRequestType": ${requestTypeId}, "exemptionFilingTypeId": 1,
      "externalStatusTypeId": ${externalStatusTypeId}, "requestStatusTypeId": ${internalstatus}}`,
      this.gethttpOptions()
    );
  }

    updateRequestCopyStatus(requestTypeId: number, externalStatusTypeId: any, internalstatus: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/RequestCopyType`
      ),
      `{ "id": ${requestTypeId}, "externalStatusTypeId": ${externalStatusTypeId}, "requestStatusTypeId": ${internalstatus}}`,
      this.gethttpOptions()
    );
  }  

    updateRequestStatus(requestTypeId: number, externalStatusTypeId: any, internalstatus: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/RequestType`
      ),
      `{ "id": ${requestTypeId}, "externalStatusTypeId": ${externalStatusTypeId}, "requestStatusTypeId": ${internalstatus}}`,
      this.gethttpOptions()
    );
  }

   updateExternalRequestStatus(requestTypeId: number, externalStatusTypeId: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/RequestType`
      ),
      `{ "id": ${requestTypeId}, "externalStatusTypeId": ${externalStatusTypeId}}`,
      this.gethttpOptions()
    );
  }

  updateFillingStatusWebPrepered(requestTypeId: number) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/RequestType`
      ),
      `{ "id": ${requestTypeId}, "exemptionFilingTypeId": 2}`,
      this.gethttpOptions()
    );
  }

  addExemptionFilingRequest(requestTypeId: number, internalstatus: any, externalStatusTypeId: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/RequestType`
      ),
      `{ "exemptionRequestType": ${requestTypeId}, "exemptionFilingTypeId": 1, 
      "externalStatusTypeId": ${externalStatusTypeId}, "requestStatusTypeId": ${internalstatus}}`,
      this.gethttpOptions()
    );
  }

  assignUserExemptionFilingRequest(requestTypeId: number) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestDetail/AssignedTo`
      ),
      `{ "id": ${requestTypeId}, "ApplicationUser": ${userId}}`,
      this.gethttpOptions()
    );
  }

  getNotes(id: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestDetail/${id}/Notes`),
      this.gethttpOptions()
    );
  }

  getPrintDoc(id: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingBasic/${id}/PrintApplication`),
      {
        headers: this.gethttpOptionsFormDataContent(),
      }
    );
  }

  getRegDetailsDoc(id: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestBasic/${id}/PrintSubmissionStatusConfirmation`),
      {
        headers: this.gethttpOptionsFormDataContent(),
      }
    );
  }

  getSummary(id: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestDetail/${id}/Summary`),
      this.gethttpOptions()
    );
  }

  addNote(id: number, note: string) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/${id}/Note`
      ),
      `{ "note": "${encodeURIComponent(note)}"}`,
      this.gethttpOptions()
    );
  }

  saveEntityInformation(id: any, entityControlNumber: any, fein: any, qualificationTypeId: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/EntityInformation`
      ),
      `{ "id": ${id}, "entityControlNumber": "${entityControlNumber}", "fein": "${fein}", "qualificationTypeId": ${qualificationTypeId} }`,
      this.gethttpOptions()
    );
  }
  
  saveQualificationTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/QualificationTab`
      ),
      data,
      this.gethttpOptions()
    );
  }

  saveRequestVerificationTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/VerificationTab`
      ),
      data,
      this.gethttpOptions()
    );
  }

  saveRequestCopyVerificationTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/RequestACopyVerificationTab`
      ),
      data,
      this.gethttpOptions()
    );
  }

  saveRequestaCopyTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/RequestACopyTab`
      ),
      data,
      this.gethttpOptions()
    );
  }

  savePhysicalAddressTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/PhysicalAddressTab`
      ),
      data,
      this.gethttpOptions()
    );
  }
  saveMailingAddressTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/MailingAddressTab`
      ),
      data,
      this.gethttpOptions()
    );
  }
  saveLicenseTab(data: any) {
    console.log('saveLicenseTab ln 227');
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/LicenseTab`
      ),
      data,
      this.gethttpOptions()
    );
  }
  saveSignatureTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/SignatureTab`
      ),
      data,
      this.gethttpOptions()
    );
  }
  saveConfirmationTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/ConfirmationTab`
      ),
      data,
      this.gethttpOptions()
    );
  }

  saveUploadTab(id: any, PaymentAndUploadMode: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestDetail/UploadTab`
      ),
      `{ "id": ${id}, "PaymentAndUploadMode": ${PaymentAndUploadMode}  }`,
      this.gethttpOptions()
    );
  }

  savePaymentTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(`PaymentInformationBasic`),
      data,
      this.gethttpOptions()
    );
  }

  getPayments(id: number) {
    var userId = this.getUser().userId;
    return this.http.get<any>(
      this.getEndpoint(
        `PaymentInformationDetail?ExemptionFilingRequestId=${id}`
      ),
      this.gethttpOptions()
    );
  }

  getExemptionAudittDetail(id: number) {
    var userId = this.getUser().userId;
    return this.http.get<any>(
      this.getEndpoint(
        `ExemptionFilingRequestDetail/Audit?id=${id}&userId=${userId}`
      ),
      this.gethttpOptions()
    );
  }

  getPaymentFee(id: number) {
    var userId = this.getUser().userId;
    return this.http.get<any>(
      this.getEndpoint(
        `PaymentInformationDetail?ExemptionFilingRequestId=${id}`
      ),
      this.gethttpOptions()
    );
  }

  getFisPaymentDetail(id: number) {
    return this.http.get<any>(
      this.getEndpoint(
        `ExemptionFilingRequestDetail/${id}/GetFisData`
      ),
      this.gethttpOptions()
    );
  }

  postPaymentOnFIS(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      data?.fisGatewayPostUrl,
      data?.fisGatewayXml
      // this.gethttpOptions()
    );
  }

  getHistory(id: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionHistoryDetail?ExemptionFilingId=${id}`),
      this.gethttpOptions()
    );
  }
  addRegistryDownload(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingDownloadDetail`
      ),
      data,
      this.gethttpOptions()
    );
  }
  saveRegistryDownload(data: any,id: any) {
    var userId = this.getUser().userId;
    return this.http.put<any>(
      this.getEndpoint(
        `ExemptionFilingDownloadDetail?id=${id}`
      ),
      data,
      this.gethttpOptions()
    );
  }
}
